import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { useEffect, useRef } from 'react';
import '../venueSchedule.scss';
import { useWindowSize } from 'react-use';

type FilterWrapperProps = {
    children: React.ReactNode;
    isFiltered: boolean;
    zIndexRef?: React.MutableRefObject<any>;
    clearFilter?: () => void;
    filterActiveIcon?: string;
    filterInactiveIcon?: string;
};

function FilterWrapper(props: Readonly<FilterWrapperProps>) {
    const { children, isFiltered, zIndexRef, clearFilter, filterActiveIcon, filterInactiveIcon } = props;
    const filterPanelRef = useRef(null);
    const { width } = useWindowSize();

    // hide the filter panel when the screen width changes
    useEffect(() => (filterPanelRef.current as any)?.hide(), [width]);

    return (
        <>
            <div className="custom-week-filter">
                <Button
                    className={`filter-wrapper-btn btn-sm left-icon-btn btn btn-custom-secondary-outline d-flex align-items-center justify-center  ${isFiltered ? 'btn-custom-primary' : ''}`}
                    icon={isFiltered ? (filterActiveIcon ?? 'ri-filter-fill') : (filterInactiveIcon ?? 'ri-filter-off-line')}
                    onClick={(e) => {
                        (filterPanelRef.current as any)?.toggle(e);
                    }}
                    outlined
                    pt={{
                        root: { style: { padding: '2.5px 0px' } },
                        icon: { style: { fontSize: '1.35rem' } },
                    }}
                />
            </div>
            <OverlayPanel
                className="filter-overlay-panel"
                ref={filterPanelRef}
                pt={{
                    content: { style: { padding: '10px', maxWidth: '250px' } },
                    root: {
                        style: {
                            borderRadius: '3px',
                            background: 'var(--bg-color)',
                            '--custom-filter-overlay-panel-z-index': zIndexRef?.current?.getElement()?.parentElement?.style?.zIndex
                                ? zIndexRef?.current?.getElement()?.parentElement?.style?.zIndex + 1
                                : 1042,
                        },
                    },
                }}
            >
                {children}
                {clearFilter && (
                    <div className="mt-4 d-flex flex-row justify-content-end align-items-center">
                        <button
                            className={`btn btn-sm ${isFiltered ? 'btn-custom-primary' : 'btn-secondary'}`}
                            type="button"
                            onClick={clearFilter}
                            disabled={!isFiltered}
                        >
                            Clear
                        </button>
                    </div>
                )}
            </OverlayPanel>
        </>
    );
}

export default FilterWrapper;
